import {asyncComputed} from '@vueuse/core';
import {getAllOrderSpecificLoadingList} from '~/api/order';
import {SpecificLoadingApi} from '~/types/order/specific-loading';
import {OrderPrice, OrderSpecialRequirement} from '~/types/types';

export const useSpecificLoadingStore = defineStore('specific-loading', () => {

  const specificLoadingList = asyncComputed(async () => {
    return await getAllOrderSpecificLoadingList()
  }, [], { lazy: true })

  function getSpecificLoadingByCode(code: string) {
    return specificLoadingList.value.find(item => item.code === code) || {} as SpecificLoadingApi
  }

  type GetSpecificLoadingListByCategory = {
    (category: 'standard'): Array<Omit<SpecificLoadingApi, 'code'> & { code: keyof OrderPrice['specificLoading']['dispatch'] }>;
    (category: SpecificLoadingApi['category_code']): Array<Omit<SpecificLoadingApi, 'code'> & { code: keyof OrderSpecialRequirement }>;
  }
  /** Возвращает список отфильтрованный по категории, и немного типизированный с уточнением поля code */
  const getSpecificLoadingListByCategory:GetSpecificLoadingListByCategory = (category: SpecificLoadingApi['category_code']): any => {
    const result = specificLoadingList.value.filter(item => item.category_code === category)
    switch (category) {
      case 'standard':
        return result
      default:
        return result
    }
  }

  return {
    specificLoadingList,
    getSpecificLoadingByCode,
    getSpecificLoadingListByCategory
  }
})
